<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
    class="no-field-space add-article-type-selection-dialog">

    <sc-dialog-title>
      {{ 'Auswahl Artikeltyp' | translate: ['erp.ui.articletype-selection.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div class="types-grid">
            <sc-bordered-tile *ngFor="let articleType of articleTypeService.getNonArchived()"
            [style]="selected === articleType ? 'selected' : ''">
                <sc-padding (click)="selectArticleType(articleType)">
                    <app-dictionary-entry-label [model]="articleType.name"></app-dictionary-entry-label>
                </sc-padding>
            </sc-bordered-tile>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.articletype-selection.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="selected == null">
          {{ 'Übernehmen' | translate: ['erp.ui.articletype-selection.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
